import React from "react";
import PropTypes from "prop-types";
import {
  ImprovedDropDown as DropDown,
  ImprovedDropDownItem as DropDownItem
} from "MODULES/shared/components/DropDown";
import * as actions from "MODULES/companies/actions";
import ConfirmDelete from "MODULES/shared/components/ConfirmDelete";
import ConfirmAction from "MODULES/shared/components/ConfirmAction";
import { connect } from "react-redux";

function Controls({
  contact,
  deleteContact,
  activateContact,
  deactivateContact
}) {
  return (
    <DropDown>
      <DropDownItem
        id="delete"
        label="Delete"
        faIcon="ban"
        hideIf={contact.primary}
        renderActive={
          <ConfirmDelete
            onConfirm={deleteContact}
            message="This will permanently delete the record and cannot be performed if the contact is associated with one or more other records."
          />
        }
      />
      <DropDownItem
        id="deactivate"
        label="Deactivate"
        faIcon="toggle-off"
        hideIf={!contact.active}
        renderActive={
          <ConfirmAction
            onConfirm={deactivateContact}
            message={
              !contact.primary
                ? "This will disable the selection of this contact from orders and quotes."
                : "Cannot deactivate the primary contact. Please assign a different primary contact before deactivating."
            }
            btnText="Deactivate"
            btnClass="btn-danger"
            showButton={!contact.primary}
          />
        }
      />
      <DropDownItem
        id="activate"
        label="Activate"
        faIcon="toggle-on"
        hideIf={contact.active}
        renderActive={
          <ConfirmAction
            onConfirm={activateContact}
            message="Are you sure you want to activate this contact?"
            btnText="Activate"
          />
        }
      />
    </DropDown>
  );
}

Controls.propTypes = {
  contact: PropTypes.shape({
    id: PropTypes.number.isRequired,
    active: PropTypes.bool,
    primary: PropTypes.bool
  }),
  deleteContact: PropTypes.func.isRequired,
  activateContact: PropTypes.func.isRequired,
  deactivateContact: PropTypes.func.isRequired
};

export default connect(undefined, (dispatch, { contact: { id } }) => ({
  deleteContact: () => dispatch(actions.destroyContact(id)),
  activateContact: () => dispatch(actions.updateContact({ id, active: true })),
  deactivateContact: () =>
    dispatch(actions.updateContact({ id, active: false }))
}))(Controls);



// WEBPACK FOOTER //
// ./app/modules/companies/components/Detail/Contacts/Controls.jsx